import { clsx } from 'clsx'
import { SVGProps } from 'react'

export const Spinner = ({
  className = '',
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={clsx('animate-spin', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}

export const Spinner2 = ({
  className = '',
  width = 16,
  height = 16,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={clsx('animate-spin', className)}
      height={height}
      width={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6718 13.9255C10.999 13.778 11.1045 13.3771 10.925 13.0663C10.7455 12.7554 10.3491 12.653 10.0182 12.7924C9.22372 13.127 8.35503 13.2601 7.49031 13.175C6.40904 13.0685 5.38828 12.626 4.5714 11.9096C3.75453 11.1932 3.18256 10.2389 2.93584 9.1808C2.68912 8.12268 2.78004 7.01385 3.19583 6.01005C3.61162 5.00625 4.33139 4.1579 5.25405 3.58415C6.17671 3.0104 7.25592 2.74008 8.3401 2.81114C9.42428 2.8822 10.459 3.29108 11.2988 3.98035C11.9705 4.53158 12.4906 5.23998 12.8158 6.03841C12.9513 6.37087 13.3039 6.57883 13.6507 6.48591C13.9974 6.393 14.2063 6.03501 14.0792 5.69926C13.6781 4.63945 13.0053 3.69908 12.1236 2.97544C11.0737 2.11385 9.78035 1.60275 8.42512 1.51392C7.0699 1.42509 5.72089 1.763 4.56756 2.48019C3.41423 3.19738 2.51452 4.25781 1.99479 5.51256C1.47505 6.76731 1.3614 8.15335 1.6698 9.476C1.9782 10.7987 2.69316 11.9915 3.71425 12.887C4.73535 13.7824 6.0113 14.3356 7.36289 14.4687C8.49809 14.5805 9.63876 14.3913 10.6718 13.9255Z"
        fill="currentColor"
      />
    </svg>
  )
}
